import { render, staticRenderFns } from "./cooming-soon-feature.vue?vue&type=template&id=b8835d32&"
import script from "./cooming-soon-feature.vue?vue&type=script&lang=js&"
export * from "./cooming-soon-feature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports